import type { RouteRecordRaw } from "vue-router"

const PartnerParkingIndex = () => import("@/views/companiesAndTerritories/partners/PartnerParkingIndex.vue")

const partnerParkingRoutes: RouteRecordRaw[] = [
    {
        path: "/admin/partner-parking",
        component: PartnerParkingIndex,
        name: "partnerParking",
        meta: {
            label: "Partner parking"
        }
    }
]

export default partnerParkingRoutes
